import axiosApi from "../axiosApi"


class UporabnikService {
  getUporabnikList() {
    return axiosApi.get("user/list");
  }

}

export default new UporabnikService();
